<!-- src/components/icons/HamburgerIcon.vue -->
<template>
<svg width="16" height="19" viewBox="0 0 16 19" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.83337 1.16663H3.00004C2.55801 1.16663 2.13409 1.34222 1.82153 1.65478C1.50897 1.96734 1.33337 2.39127 1.33337 2.83329V16.1666C1.33337 16.6087 1.50897 17.0326 1.82153 17.3451C2.13409 17.6577 2.55801 17.8333 3.00004 17.8333H13C13.4421 17.8333 13.866 17.6577 14.1786 17.3451C14.4911 17.0326 14.6667 16.6087 14.6667 16.1666V6.99996M8.83337 1.16663L14.6667 6.99996M8.83337 1.16663V6.99996H14.6667" stroke="#E0E0E0" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
</svg>


</template>
      
